<script setup>
const { sanitize } = useUtils();      

const props = defineProps({
  data: Object,
  pulseData: Object,
  gridData: Object
});
const { getRecShared } = useLeadGenRecData();
const { data: recSharedData } = await getRecShared();
const learningData = toRef(props, 'pulseData');
const learningStyleData = toRef(props, 'gridData');

const relations = props.data.sharedContent && props.data.learningStyleRelations.length > 0 
  || props.data.sharedContent 
    ? recSharedData.value.data.attributes.learningStyleRelations 
    : props.data.learningStyleRelations ;

// Iterate over each key-value pair in the relations object
for (const key in sanitize(relations)) {
  if (Object.hasOwnProperty.call(relations, key)) {
    const relation = relations[key];

    // Extract the learningStyleLabels array from the current relation object
    const learningStyleLabels = relation.learningStyleLabels;

    // Initialize an array to store the extracted values
    const values = [];

    // Iterate over each label in the learningStyleLabels array
    learningStyleLabels.forEach(label => {
        // Extract the value from the label
        const match = label.match(/\((\d+)\)/);
        if (match) {
            // Add the extracted value to the values array
            values.push(match[1]);
        }
    });

    // If values were found, assign the array to the value property, otherwise, assign null
    relation.value = values.length > 0 ? values : null;
  }
}
const items = props.data.sharedContent && props.data.learningStyle.length > 0 
  || props.data.sharedContent 
    ? recSharedData.value.data.attributes.learningStyle 
    : props.data.learningStyle ;

const itemsWithValue = items.map(item => {
  const value = item.learningStyleLabels.match(/\((\d+)\)$/)[1];
  return { ...item, value };
});

const selectedItems = ref([]);
const emit = defineEmits(['nestedStep', 'validateStep']);

const toggleSelection = (item) => {
  const index = selectedItems.value.indexOf(item.value);
  if (index === -1) {
    selectedItems.value.push(item.value);
  } else {
    selectedItems.value.splice(index, 1);
  }
  const nestedSteps = getNestedSteps(selectedItems.value);
  if( nestedSteps.attributes) {
    emit("nestedStep", nestedSteps.attributes);
  } else {
    emit("nestedStep", false);
  }
  emit("validateStep", {
    value: selectedItems.value,
    component: props.data.component
  });
  learningData.value.learningStyleTypeIDs = selectedItems.value;
  learningStyleData.value.format = selectedItems.value;
};

const isSelected = (value) => {
  return selectedItems.value.includes(value);
};

// Function to get nested steps based on selected learning styles
const getNestedSteps = (selectedValues) => {
  const nestedSteps = {}; 

  if (selectedValues.length === 0) {
    return nestedSteps; // If no items selected, return an empty object
  }
  
  // If only one value is selected, find the corresponding item and return its steps
  if (selectedValues.length === 1) {
    const selectedValue = selectedValues[0];
    const matchingItem = relations.find(item => item.value.length === 1 && item.value[0] === selectedValue);
    if (matchingItem) {
      nestedSteps.attributes = matchingItem.steps.data[0].attributes; // Assign steps to attributes property
    }
    return nestedSteps;
  }

  // If multiple values are selected, find the item that contains all selected values
  const matchingItem = relations.find(item => {
    return selectedValues.every(value => item.value.includes(value));
  });

  // If a matching item is found, extract its steps
  if (matchingItem) {
    nestedSteps.attributes = matchingItem.steps.data[0].attributes; // Assign steps to attributes property
  }
  return nestedSteps;
};
onMounted(() => {
  const parentElement = document.getElementById('learning-style').parentElement.parentElement.parentElement
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
          value: selectedItems.value,
          component: props.data.component
        });
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <div class="learning-style-select btn-wrapper btn-group" id="learning-style">
    <button
      v-for="item in itemsWithValue"
      :key="item.id"
      class="btn-quiz w-100"
      :class="{ active: isSelected(item.value) }"
      @click="toggleSelection(item)"
    >
      <span v-if="isSelected(item.value)" class="bi-check"></span>
      <span v-else class="space"></span>
      <span>{{ item.learningStyle }}</span>
    </button>
  </div>
</template>


<style lang="scss" scoped>


</style>
